<template>
  <div class="wg-quetion">
    <div class="themesflat-container">
      <div class="row">
        <div class="col-12">
          <div class="heading-section text-center">
            <div class="title ">
              {{ contact.question }}
            </div>
            <p class=" question-description">
              {{ contact.question_description }}
            </p>
            <div class="divider "><div></div></div>
          </div>
        </div>
        <QuestionFormComponent />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { langStore } from "../../langStore";
import QuestionFormComponent from "./QuestionFormComponent.vue";

export default {
  name: "QuestionComponent",
  components: {
    QuestionFormComponent
  },
  
  data() {
    return {
      langStore,
      contact: {},
    };
  },

  watch: {
    "langStore.lang"() {
      this.fetchContact();
    },
  },

  mounted() {
    this.fetchContact();
  },

  methods: {
    fetchContact() {
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/api/contact`, {
          params: { lang: this.langStore.lang },
        })
        .then((response) => {
          this.contact = response.data;
        })
        .catch((error) => {
          console.error("There was an error fetching the data:", error);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.question-description {
  padding-left: 15%;
  padding-right: 15%;
}
</style>
